module.exports = __webpack_public_path__ + "img/zhaoshang_erweima@2x.e7f4b036.png";